import { Box, Checkbox, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import React, { useEffect } from 'react';
import { BiCtaNames, BiNotificationTypes } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../hooks/use-open-article-by-editor-host';
import { dataHooks } from '../../utils/datahooks';
export const DomOrderCheckbox = _ref => {
  let {
    isChecked,
    setIsChecked
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  useEffect(() => {
    biLogger.notificationView({
      notificationType: BiNotificationTypes.AutoDOMOrder
    });
  }, [biLogger]);
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    backgroundColor: "D75",
    borderRadius: "6px",
    direction: "vertical",
    gap: "9px",
    marginBottom: "SP3",
    padding: "SP1 9px 9px 9px",
    verticalAlign: "space-between",
    width: "252px"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isChecked,
    dataHook: dataHooks.domOrderCheckbox,
    size: "medium",
    vAlign: "top",
    onChange: () => {
      biLogger.notificationCtaClick({
        ctaName: `${BiCtaNames.AutoDomOrderCheckbox}-${isChecked ? 'off' : 'on'}`,
        notificationType: BiNotificationTypes.AutoDOMOrder
      });
      setIsChecked(!isChecked);
    }
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: event => {
          event.preventDefault();
          biLogger.notificationCtaClick({
            ctaName: BiCtaNames.AutoDomOrderInfo,
            notificationType: BiNotificationTypes.AutoDOMOrder
          });
          openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-organizing-DOM-help');
        }
      })
    },
    i18nKey: "accessibility-wizard.welcome-screen.dom-checkbox.label",
    t: t
  })))));
};
export default DomOrderCheckbox;
//# sourceMappingURL=dom-order-checkbox.js.map